import useSEO, { SEO_CONFIG } from '@/hooks/useSEO';

export default function About() {
  // SEO optimization for about page
  useSEO(SEO_CONFIG.about);
  
  return (
    <div className="py-24 lg:py-32">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-5xl lg:text-6xl font-heading text-primary mb-8 text-center">
          Brasserie artisanale Soif de Provence
        </h1>
        
        <div className="prose prose-lg max-w-none">
          <div className="mb-12 rounded-2xl overflow-hidden shadow-xl">
            <img
              src="https://customer-assets.emergentagent.com/job_craft-beer-shop-1/artifacts/9ejd8ah8_5440f635-9b87-4cd6-b33e-bc0b6e30bbe4~1.jpg"
              alt="Brasserie Soif de Provence à Saint-Rémy-de-Provence"
              className="w-full h-96 object-cover"
            />
          </div>
          
          <div className="space-y-6 text-foreground/80 text-lg">
            <p>
              <strong className="text-primary">Soif de Provence</strong> est née d&apos;une passion pour la bière artisanale et d&apos;un engagement sans compromis envers la qualité. Notre brasserie artisanale, installée à Saint-Rémy-de-Provence au cœur des Alpilles, produit des bières de caractère selon des méthodes rigoureuses et éprouvées.
            </p>
            
            <p>
              Nous proposons une gamme de bières artisanales, élaborées avec une attention minutieuse à chaque étape du processus de brassage. Notre approche privilégie la cohérence des ingrédients, la maîtrise technique, et le respect des traditions brassicoles provençales.
            </p>
            
            <div className="my-12 rounded-2xl overflow-hidden shadow-xl">
              <img
                src="https://customer-assets.emergentagent.com/job_craft-beer-shop-1/artifacts/38t3mz2z_3b524c0b-8eb2-4ad0-ae9e-f8a6eb2b2585~1.jpg"
                alt="Processus de brassage artisanal"
                className="w-full h-96 object-cover"
              />
            </div>
            
            <h2 className="text-3xl font-heading text-primary mt-12 mb-6">Nos bières artisanales</h2>
            
            <ul className="space-y-4">
              <li>
                <strong className="text-primary">Blanche</strong> : Légère et rafraîchissante, aux notes d&apos;agrumes et de coriandre.
              </li>
              <li>
                <strong className="text-primary">Blonde</strong> : Douce et équilibrée, aux arômes floraux et maltés.
              </li>
              <li>
                <strong className="text-primary">IPA</strong> : Houblonnée et aromatique, aux notes tropicales et d&apos;agrumes.
              </li>
              <li>
                <strong className="text-primary">Porter</strong> : Riche et torréfiée, aux arômes de café et de chocolat.
              </li>
              <li>
                <strong className="text-primary">Ambrée (British Strong Ale)</strong> : Maltée et caramélisée, une bière de caractère.
              </li>
              <li>
                <strong className="text-primary">Golden Strong Ale</strong> : Puissante et élégante, aux arômes d&apos;épices et de fruits blancs.
              </li>
              <li>
                <strong className="text-primary">Stout</strong> : Noire et gourmande, aux malts torréfiés, douce et soyeuse.
              </li>
            </ul>
            
            <div className="mt-12 p-8 bg-secondary rounded-2xl border border-border">
              <h3 className="text-2xl font-heading text-primary mb-4">Notre engagement</h3>
              <ul className="space-y-3">
                <li className="flex items-start">
                  <span className="text-accent mr-2 text-xl">✓</span>
                  <span>Production artisanale avec équipements professionnels</span>
                </li>
                <li className="flex items-start">
                  <span className="text-accent mr-2 text-xl">✓</span>
                  <span>Sélection rigoureuse des matières premières</span>
                </li>
                <li className="flex items-start">
                  <span className="text-accent mr-2 text-xl">✓</span>
                  <span>Contrôle qualité à chaque étape du brassage</span>
                </li>
                <li className="flex items-start">
                  <span className="text-accent mr-2 text-xl">✓</span>
                  <span>Respect des traditions brassicoles</span>
                </li>
              </ul>
            </div>
            
            <div className="mt-12 text-center flex flex-wrap gap-4 justify-center">
              <a
                href="/nos-bieres"
                className="inline-block bg-primary text-primary-foreground hover:bg-primary/90 rounded-full px-8 py-6 text-lg font-medium transition-transform hover:-translate-y-1 shadow-lg hover:shadow-xl"
              >
                Découvrir notre gamme de bières
              </a>
              <a
                href="/points-de-vente"
                className="inline-block border-2 border-primary text-primary hover:bg-primary/5 rounded-full px-8 py-6 text-lg font-medium transition-transform hover:-translate-y-1"
              >
                Nos points de vente en Provence
              </a>
              <a
                href="/professionnels"
                className="inline-block border-2 border-primary text-primary hover:bg-primary/5 rounded-full px-8 py-6 text-lg font-medium transition-transform hover:-translate-y-1"
              >
                Espace professionnels
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}